import { Controller } from "@hotwired/stimulus"

// Dispatches global events to control the chat widget from anywhere in the DOM.
export default class extends Controller {
  open(event) {
    event?.preventDefault()
    window.dispatchEvent(new CustomEvent("chat-widget:open", { bubbles: false }))
  }

  close(event) {
    event?.preventDefault()
    window.dispatchEvent(new CustomEvent("chat-widget:close", { bubbles: false }))
  }

  toggle(event) {
    event?.preventDefault()
    window.dispatchEvent(new CustomEvent("chat-widget:toggle", { bubbles: false }))
  }
}
